module.exports = __webpack_public_path__ + "img/readon_normal.f2d3d733.png";